import { css } from 'styled-components';

export const PAGE_GUTTERS = { compact: 12, classic: 64, mobile: 12 };

// Layout owns the space between the page and the sidebars. Page containers
// must not add a second gutter, including when rendered inside another page.
export const pageContainerStyles = css`
  min-width: 0;
  max-width: 100%;
  width: auto;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
`;

// Public documents are rendered outside Layout, so they own their page gutter.
export const standalonePageStyles = css`
  ${pageContainerStyles}
  padding: 24px ${PAGE_GUTTERS.classic}px;

  @media (max-width: 768px) {
    padding: 6px ${PAGE_GUTTERS.mobile}px;
  }
`;
